module.exports = __webpack_public_path__ + "img/tube-SPD250.aca01295.svg";